import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { AuthProvider } from './context/AuthContext'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
)

// updated at 2025-11-07

// updated at 2025-11-07

// updated at 2025-11-07

// updated at 2025-11-07

// updated at 2025-11-07

// updated at 2025-11-07

// updated at 2025-11-07

// updated at 2025-11-07

// updated at 2025-11-07

// updated at 2025-11-07

// updated at 2025-11-07
